(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.documentElement;
    var announcementBar = document.querySelector('.announcement-bar');
    if (!announcementBar) return;

    var ticking = false;

    function updateAnnouncementBarState() {
      var barHeight = announcementBar.offsetHeight;
      var isAtTop = window.scrollY <= 0;

      root.style.setProperty('--announcement-bar-height', barHeight + 'px');
      root.toggleAttribute('data-announcement-bar-hidden', !isAtTop);
      ticking = false;
    }

    function requestStateUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateAnnouncementBarState);
    }

    updateAnnouncementBarState();
    window.addEventListener('scroll', requestStateUpdate, { passive: true });
    window.addEventListener('resize', requestStateUpdate);

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestStateUpdate).observe(announcementBar);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) return;

    document.querySelectorAll('.collection-page__grid-video-media').forEach(function (video) {
      video.pause();
      video.removeAttribute('autoplay');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.site-footer__field').forEach(function (field) {
      var input = field.querySelector('input[type="email"]');
      if (!input) return;

      function updateFieldState() {
        field.classList.toggle('has-value', input.value.trim().length > 0);
      }

      input.addEventListener('input', updateFieldState);
      input.addEventListener('change', updateFieldState);
      updateFieldState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var announcementBar = document.querySelector('.announcement-bar');
    var activeItem = null;
    var suppressFocusOpenItem = null;
    var searchItem = header.querySelector('[data-header-search-item]');
    var cartCounts = document.querySelectorAll('[data-header-cart-count]');
    var wishlistCounts = document.querySelectorAll('[data-header-wishlist-count]');
    var searchCloseTimer = null;
    var wishlistKey = 'ssk:wishlist';

    function containsHeaderArea(target) {
      return Boolean(
        target &&
          (header.contains(target) || (announcementBar && announcementBar.contains(target)))
      );
    }

    function setExpanded(item, expanded) {
      var link = item.querySelector('.header__menu-link[aria-expanded]');
      if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function setActiveItem(item) {
      if (activeItem === item) return;

      if (activeItem) {
        activeItem.classList.remove('is-mega-menu-open');
        setExpanded(activeItem, false);
      }

      activeItem = item;

      if (activeItem) {
        activeItem.classList.add('is-mega-menu-open');
        setExpanded(activeItem, true);
      }
    }

    function setSearchOpen(open) {
      if (!searchItem) return;

      var wasOpen = searchItem.classList.contains('is-search-menu-open');

      if (open) {
        window.clearTimeout(searchCloseTimer);
        searchItem.classList.remove('is-search-menu-closing');
        setActiveItem(null);
        if (!wasOpen) document.dispatchEvent(new CustomEvent('header-search:open'));
      }

      searchItem.classList.toggle('is-search-menu-open', open);

      if (!open && wasOpen) {
        searchItem.classList.add('is-search-menu-closing');
        window.clearTimeout(searchCloseTimer);
        searchCloseTimer = window.setTimeout(function () {
          searchItem.classList.remove('is-search-menu-closing');
        }, 180);
      }

      var link = searchItem.querySelector('.header__search-link[aria-expanded]');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!open) {
        var searchInput = searchItem.querySelector('[data-header-search-input]');
        if (searchInput && document.activeElement === searchInput) searchInput.blur();
      }
    }

    function preloadMegaMenuImages(item) {
      item.querySelectorAll('.header__mega-menu-image:not([data-header-image-preloaded="true"])').forEach(function (img) {
        img.dataset.headerImagePreloaded = 'true';
        img.loading = 'eager';
        img.fetchPriority = 'high';

        var preloadImage = new Image();
        if (img.sizes) preloadImage.sizes = img.sizes;
        if (img.srcset) preloadImage.srcset = img.srcset;
        preloadImage.src = img.currentSrc || img.src;
      });
    }

    document.addEventListener('cart:count:update', function (event) {
      var count = Math.max(0, Number(event.detail && event.detail.count) || 0);
      cartCounts.forEach(function (cartCount) {
        cartCount.textContent = String(count);
        cartCount.classList.toggle('is-empty', count === 0);
      });
    });

    function getWishlist() {
      try {
        var stored = window.localStorage.getItem(wishlistKey);
        var parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function updateWishlistCount(handles) {
      var count = Array.isArray(handles) ? handles.length : 0;
      wishlistCounts.forEach(function (wishlistCount) {
        wishlistCount.textContent = String(count);
        wishlistCount.classList.toggle('is-empty', count === 0);
      });
    }

    header.querySelectorAll('[data-header-menu-item]').forEach(function (item) {
      if (!item.querySelector('[data-header-mega-menu]')) {
        item.addEventListener('pointerenter', function () {
          setActiveItem(null);
        });

        item.addEventListener('focusin', function () {
          setActiveItem(null);
        });

        return;
      }

      item.addEventListener('pointerenter', function () {
        setSearchOpen(false);
        preloadMegaMenuImages(item);
        setActiveItem(item);
      });

      item.addEventListener('focusin', function () {
        if (suppressFocusOpenItem === item) {
          setActiveItem(null);
          return;
        }

        setSearchOpen(false);
        preloadMegaMenuImages(item);
        setActiveItem(item);
      });
    });

    header.querySelectorAll('.header__action-link').forEach(function (actionLink) {
      actionLink.addEventListener('pointerenter', function () {
        setActiveItem(null);
      });

      actionLink.addEventListener('focusin', function () {
        setActiveItem(null);
      });
    });

    if (searchItem) {
      var searchInput = searchItem.querySelector('[data-header-search-input]');
      var searchLink = searchItem.querySelector('.header__search-link');
      var searchOverlay = searchItem.querySelector('[data-header-search-overlay]');

      if (searchLink) {
        searchLink.addEventListener('click', function (event) {
          event.preventDefault();
          setSearchOpen(true);
          if (searchInput) searchInput.focus({ preventScroll: true });
        });
      }

      if (searchOverlay) {
        searchOverlay.addEventListener('click', function () {
          setSearchOpen(false);
        });
      }
    }

    header.addEventListener('pointerleave', function (event) {
      if (!containsHeaderArea(event.relatedTarget)) {
        setActiveItem(null);
      }
    });

    if (announcementBar) {
      announcementBar.addEventListener('pointerleave', function (event) {
        if (!containsHeaderArea(event.relatedTarget)) {
          setActiveItem(null);
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (searchItem && searchItem.contains(event.target)) return;
      setActiveItem(null);
      setSearchOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (activeItem) {
        var closingItem = activeItem;
        var activeLink = closingItem.querySelector('.header__menu-link');
        suppressFocusOpenItem = closingItem;
        setActiveItem(null);
        if (activeLink && typeof activeLink.focus === 'function') {
          activeLink.focus({ preventScroll: true });
        }
        window.requestAnimationFrame(function () {
          if (suppressFocusOpenItem === closingItem) suppressFocusOpenItem = null;
        });
      }

      if (searchItem && searchItem.classList.contains('is-search-menu-open')) {
        var searchLink = searchItem.querySelector('.header__search-link');
        setSearchOpen(false);
        if (searchLink && typeof searchLink.focus === 'function') {
          searchLink.focus({ preventScroll: true });
        }
      }
    });

    header.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () {
        if (!header.contains(document.activeElement)) {
          setActiveItem(null);
        }
      });
    });

    updateWishlistCount(getWishlist());

    window.addEventListener('wishlist:updated', function (event) {
      updateWishlistCount(event.detail && event.detail.handles ? event.detail.handles : getWishlist());
    });

    window.addEventListener('storage', function (event) {
      if (event.key === wishlistKey) updateWishlistCount(getWishlist());
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.layout-carousel:not([data-carousel-initialized="true"])').forEach(function (section) {
      section.dataset.carouselInitialized = 'true';

      var track = section.querySelector('[data-carousel-track]');
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');
      var mobileQuery = window.matchMedia('(max-width: 749px)');

      if (!track) return;

      if (track.hasAttribute('data-carousel-random')) {
        var limit = Number(track.dataset.carouselLimit || 4);

        Array.from(track.children)
          .sort(function () {
            return Math.random() - 0.5;
          })
          .forEach(function (item, index) {
            if (index < limit) {
              track.appendChild(item);
            } else {
              item.remove();
            }
          });
      }

      if (!prev || !next) return;

      var realItems = [];
      var cloneCount = 0;
      var isAnimating = false;
      var scrollTimer = null;
      var resizeTimer = null;

      function getGap() {
        return parseFloat(window.getComputedStyle(track).columnGap) || 0;
      }

      function getStep() {
        var item = track.querySelector('.layout-carousel__item:not([data-carousel-clone])');
        return item ? item.getBoundingClientRect().width + getGap() : track.clientWidth;
      }

      function getVisibleCount() {
        var step = getStep();
        return step ? Math.max(1, Math.round(track.clientWidth / step)) : 1;
      }

      function getScrollIndex() {
        var step = getStep();
        return step ? Math.round(track.scrollLeft / step) : 0;
      }

      function setScrollLeft(left) {
        var previousSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = left;
        track.offsetHeight;
        track.style.scrollSnapType = previousSnap;
      }

      function makeClone(item) {
        var clone = item.cloneNode(true);

        clone.dataset.carouselClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
          element.setAttribute('tabindex', '-1');
        });

        return clone;
      }

      function getRealIndex() {
        if (realItems.length === 0) return 0;

        var index = getScrollIndex() - cloneCount;
        return ((index % realItems.length) + realItems.length) % realItems.length;
      }

      function normalizePosition() {
        if (realItems.length <= 1) return;

        var step = getStep();
        if (!step) return;

        var index = getScrollIndex();

        if (index < cloneCount) {
          setScrollLeft((index + realItems.length) * step);
        } else if (index >= cloneCount + realItems.length) {
          setScrollLeft((index - realItems.length) * step);
        }
      }

      function scheduleNormalize() {
        if (isAnimating) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(normalizePosition, 220);
      }

      function easeInOutCubic(progress) {
        return progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      }

      function setControlsDisabled(disabled) {
        prev.disabled = disabled;
        next.disabled = disabled;
      }

      function slideBy(direction) {
        if (isAnimating) return;

        var step = getStep();
        if (!step) return;

        var startIndex = getScrollIndex();
        var target = (startIndex + direction) * step;
        var previousSnap = track.style.scrollSnapType;
        var duration = 420;
        var startedAt = window.performance.now();

        isAnimating = true;
        setControlsDisabled(true);
        window.clearTimeout(scrollTimer);
        track.style.scrollSnapType = 'none';

        function animate(now) {
          var progress = Math.min((now - startedAt) / duration, 1);

          track.scrollLeft = startIndex * step + (target - startIndex * step) * easeInOutCubic(progress);

          if (progress < 1) {
            window.requestAnimationFrame(animate);
          } else {
            setScrollLeft(target);
            normalizePosition();
            track.style.scrollSnapType = previousSnap;
            isAnimating = false;
            setControlsDisabled(false);
          }
        }

        window.requestAnimationFrame(animate);
      }

      function buildLoop(startIndex) {
        track.querySelectorAll('[data-carousel-clone]').forEach(function (clone) {
          clone.remove();
        });

        realItems = Array.from(track.children);
        cloneCount = 0;

        if (mobileQuery.matches) {
          setScrollLeft(0);

          if (prev && next) {
            prev.disabled = true;
            next.disabled = true;
          }

          return;
        }

        if (realItems.length <= 1) {
          prev.disabled = true;
          next.disabled = true;
          return;
        }

        prev.disabled = false;
        next.disabled = false;
        cloneCount = Math.min(getVisibleCount() + 2, realItems.length);

        realItems.slice(-cloneCount).forEach(function (item) {
          track.insertBefore(makeClone(item), track.firstChild);
        });

        realItems.slice(0, cloneCount).forEach(function (item) {
          track.appendChild(makeClone(item));
        });

        setScrollLeft((cloneCount + (startIndex || 0)) * getStep());
      }

      prev.addEventListener('click', function () {
        slideBy(-1);
      });

      next.addEventListener('click', function () {
        slideBy(1);
      });

      track.addEventListener('scroll', scheduleNormalize, { passive: true });

      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          if (isAnimating) return;

          buildLoop(getRealIndex());
        }, 180);
      });

      buildLoop(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-faq"] && !Shopify.designMode) return;
  try {
    
  function initLayoutFaq(section) {
    var items = section.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      if (item.dataset.faqInitialized === 'true') return;

      var summary = item.querySelector('summary');
      var panel = item.querySelector('[data-faq-panel]');

      if (!summary || !panel) return;

      item.dataset.faqInitialized = 'true';

      if (item.open) {
        panel.style.height = 'auto';
        panel.style.opacity = '1';
      }

      summary.addEventListener('click', function (event) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        event.preventDefault();

        if (item.dataset.faqAnimating === 'true') return;

        if (item.open) {
          item.dataset.faqAnimating = 'true';
          panel.style.height = panel.scrollHeight + 'px';
          panel.style.opacity = '1';

          requestAnimationFrame(function () {
            panel.style.height = '0px';
            panel.style.opacity = '0';
          });

          panel.addEventListener('transitionend', function closePanel(transitionEvent) {
            if (transitionEvent.propertyName !== 'height') return;

            panel.removeEventListener('transitionend', closePanel);
            item.open = false;
            item.dataset.faqAnimating = 'false';
          });

          return;
        }

        item.dataset.faqAnimating = 'true';
        item.open = true;
        panel.style.height = '0px';
        panel.style.opacity = '0';

        requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + 'px';
          panel.style.opacity = '1';
        });

        panel.addEventListener('transitionend', function openPanel(transitionEvent) {
          if (transitionEvent.propertyName !== 'height') return;

          panel.removeEventListener('transitionend', openPanel);
          panel.style.height = 'auto';
          item.dataset.faqAnimating = 'false';
        });
      });
    });
  }

  document.querySelectorAll('.layout-faq').forEach(initLayoutFaq);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.layout-faq');

    if (section) {
      initLayoutFaq(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.product:not([data-product-initialized="true"])').forEach(function (productSection) {
      productSection.dataset.productInitialized = 'true';

      var variantSelect = productSection.querySelector('[data-variant-select]');
      var variantData = productSection.querySelector('[data-product-variants]');
      var variantImageData = productSection.querySelector('[data-product-variant-images]');
      if (!variantSelect || !variantData) return;

      var variants = JSON.parse(variantData.textContent || '[]');
      var variantImages = variantImageData ? JSON.parse(variantImageData.textContent || '{}') : {};
      var productDetails = productSection.querySelector('[data-product-details]');
      var imageTrack = productSection.querySelector('[data-product-media-track]');
      var mediaProgress = productSection.querySelector('[data-product-media-progress]');
      var optionInputs = productSection.querySelectorAll('[data-option-position]');
      var addonInputs = productSection.querySelectorAll('.product-addons input[type="radio"]');
      var imageFrames = productSection.querySelectorAll('[data-product-image-id]');
      var priceElement = productSection.querySelector('[data-product-price]');
      var submitButton = productSection.querySelector('.product-form__submit');
      var submitButtons = productSection.querySelectorAll('.product-form__submit');
      var submitLabels = productSection.querySelectorAll('[data-product-submit-label]');
      var submitPrices = productSection.querySelectorAll('[data-product-submit-price]');
      var mobileSubmitBar = productSection.querySelector('[data-product-mobile-submit-bar]');
      var productTabs = productSection.querySelector('[data-product-tabs]');
      var tabsNav = productSection.querySelector('.product-tabs__nav');
      var sizeChartModal = document.querySelector('[data-size-chart-modal]');
      var sizeChartPanel = sizeChartModal ? sizeChartModal.querySelector('.size-chart-modal__panel') : null;
      var sizeChartCloseTimer = null;
      var sizeChartPreviousFocus = null;
      var releaseSizeChartAccessibility = null;
      var wishlistKey = 'ssk:wishlist';
      var wishlistButton = productSection.querySelector('[data-wishlist-toggle]');
      var currentVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantSelect.value);
      }) || variants[0];

      function getWishlist() {
        try {
          var stored = window.localStorage.getItem(wishlistKey);
          var parsed = stored ? JSON.parse(stored) : [];
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      function setWishlist(handles) {
        window.localStorage.setItem(wishlistKey, JSON.stringify(handles));
        window.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { handles: handles }
        }));
      }

      function updateWishlistButton(handles) {
        if (!wishlistButton) return;

        var handle = wishlistButton.dataset.productHandle;
        var title = wishlistButton.dataset.productTitle || 'product';
        var isActive = handles.indexOf(handle) !== -1;

        wishlistButton.classList.toggle('is-active', isActive);
        wishlistButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        wishlistButton.setAttribute('aria-label', (isActive ? 'Remove ' : 'Add ') + title + (isActive ? ' from wishlist' : ' to wishlist'));
      }

      if (wishlistButton && wishlistButton.dataset.wishlistInitialized !== 'true') {
        wishlistButton.dataset.wishlistInitialized = 'true';
        updateWishlistButton(getWishlist());

        wishlistButton.addEventListener('click', function () {
          var handle = wishlistButton.dataset.productHandle;
          if (!handle) return;

          var handles = getWishlist();
          var index = handles.indexOf(handle);

          if (index === -1) {
            handles.push(handle);
          } else {
            handles.splice(index, 1);
          }

          setWishlist(handles);
        });

        window.addEventListener('wishlist:updated', function (event) {
          updateWishlistButton(event.detail && event.detail.handles ? event.detail.handles : getWishlist());
        });

        window.addEventListener('storage', function (event) {
          if (event.key === wishlistKey) updateWishlistButton(getWishlist());
        });
      }

      function formatProductPrice(cents) {
        cents = Number(cents);
        if (!Number.isFinite(cents)) cents = 0;

        var currencySymbol = productSection.dataset.productCurrencySymbol || '';

        try {
          return currencySymbol + new Intl.NumberFormat(document.documentElement.lang || 'en', {
            minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2
          }).format(cents / 100);
        } catch (error) {
          return currencySymbol + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
        }
      }

      function setPriceText(element, value) {
        if (!element || element.textContent === value) return;

        element.textContent = value;
      }

      function getSelectedAddonPrice() {
        return Array.from(productSection.querySelectorAll('[data-nested-cart-addon][data-addon-price]:checked')).reduce(function (total, input) {
          return total + Number(input.dataset.addonPrice || 0);
        }, 0);
      }

      function syncPrice() {
        if (!priceElement || !currentVariant) return;
        var formattedPrice = formatProductPrice(Number(currentVariant.price) + getSelectedAddonPrice());
        setPriceText(priceElement, formattedPrice);
        submitPrices.forEach(function (submitPrice) {
          setPriceText(submitPrice, formattedPrice);
        });
      }

      function getCheckedOptionValue(pattern) {
        var matchingInput = Array.from(optionInputs).find(function (input) {
          var optionName = String(input.dataset.optionName || '').toLowerCase();
          return input.checked && pattern.test(optionName);
        });

        return matchingInput ? matchingInput.value : '';
      }

      function escapeText(value) {
        var element = document.createElement('span');
        element.textContent = value;
        return element.innerHTML;
      }

      function syncSubmitLabel() {
        if (!submitLabels.length) return;

        var label = currentVariant && currentVariant.available ? 'Add to Cart' : 'Sold Out';
        var selectedSize = getCheckedOptionValue(/size/);
        var selectedAddon = getCheckedOptionValue(/addon|add-on|add on|dupatta|hijab/);

        if (selectedSize) {
          label += ' <span class="product-form__submit-option">- ' + escapeText(selectedSize) + '</span>';
        }
        if (selectedAddon) {
          label += ' <span class="product-form__submit-option">- ' + escapeText(selectedAddon) + '</span>';
        }

        submitLabels.forEach(function (submitLabel) {
          submitLabel.innerHTML = label;
        });
      }

      function syncSubmitState() {
        var isAvailable = Boolean(currentVariant && currentVariant.available);
        submitButtons.forEach(function (button) {
          button.disabled = !isAvailable;
          button.classList.toggle('is-disabled', !isAvailable);
        });
      }

      function getSelectedOptions() {
        var selected = [];
        optionInputs.forEach(function (input) {
          if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return selected;
      }

      function syncVariant(skipImageSync) {
        var selectedOptions = getSelectedOptions();
        var matchingVariant = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });

        optionInputs.forEach(function (input) {
          if (!input.checked) return;

          var currentLabel = productSection.querySelector('[data-option-current="' + input.dataset.optionPosition + '"]');
          if (currentLabel) currentLabel.textContent = input.value;
        });

        if (matchingVariant) {
          currentVariant = matchingVariant;
          variantSelect.value = matchingVariant.id;
          syncPrice();
          syncOptionAvailability();
          syncSubmitState();
          syncSubmitLabel();
          if (!skipImageSync) syncProductImage(matchingVariant.id);
        } else {
          currentVariant = null;
          variantSelect.value = '';
          syncOptionAvailability();
          syncSubmitState();
          syncSubmitLabel();
        }
      }

      function hasAvailableVariantForOptions(candidateOptions) {
        return variants.some(function (variant) {
          if (!variant.available) return false;

          return variant.options.every(function (option, index) {
            return candidateOptions[index] === undefined || candidateOptions[index] === option;
          });
        });
      }

      function syncOptionAvailability() {
        var selectedOptions = getSelectedOptions();

        optionInputs.forEach(function (input) {
          var candidateOptions = selectedOptions.slice();
          candidateOptions[Number(input.dataset.optionPosition) - 1] = input.value;

          input.disabled = !hasAvailableVariantForOptions(candidateOptions);
        });
      }

      function syncProductImage(variantId) {
        var imageId = variantImages[String(variantId)];

        if (!imageId || !imageFrames.length) return;

        var matchingFrame = productSection.querySelector('[data-product-image-id="' + imageId + '"]');
        if (!matchingFrame) return;

        if (window.matchMedia('(max-width: 749px)').matches && imageTrack) {
          imageTrack.scrollTo({
            left: matchingFrame.offsetLeft - imageTrack.offsetLeft,
            behavior: 'smooth',
          });
          return;
        }

        matchingFrame.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function syncMediaProgress() {
        if (!imageTrack || !mediaProgress || imageFrames.length < 2) return;

        var slideWidth = imageTrack.clientWidth;
        if (!slideWidth) return;

        var index = Math.round(imageTrack.scrollLeft / slideWidth);
        var boundedIndex = Math.max(0, Math.min(index, imageFrames.length - 1));
        var value = (boundedIndex + 1) / imageFrames.length;

        mediaProgress.style.transform = 'scaleX(' + value + ')';
      }

      function isFooterVisible() {
        var footer = document.querySelector('.site-footer');
        if (!footer) return false;

        var footerRect = footer.getBoundingClientRect();

        return footerRect.top < window.innerHeight && footerRect.bottom > 0;
      }

      function syncMobileSubmitBar() {
        if (!mobileSubmitBar || !submitButton) return;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var shouldShow = isMobile
          && submitButton.getBoundingClientRect().bottom <= 0
          && !isFooterVisible();

        mobileSubmitBar.classList.toggle('is-visible', shouldShow);
        mobileSubmitBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      function requestMobileSubmitBarSync() {
        if (productSection.dataset.mobileSubmitBarSyncPending === 'true') return;

        productSection.dataset.mobileSubmitBarSyncPending = 'true';
        window.requestAnimationFrame(function () {
          delete productSection.dataset.mobileSubmitBarSyncPending;
          syncMobileSubmitBar();
        });
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          syncVariant(false);
        });
      });

      addonInputs.forEach(function (input) {
        if (input.dataset.optionPosition) return;

        input.addEventListener('change', function () {
          syncPrice();
          syncSubmitLabel();
        });
      });

      syncVariant(true);
      syncPrice();
      syncOptionAvailability();
      syncSubmitState();
      syncSubmitLabel();
      syncMediaProgress();
      syncMobileSubmitBar();

      if (imageTrack) {
        imageTrack.addEventListener('scroll', syncMediaProgress, { passive: true });
      }

      if (mobileSubmitBar) {
        window.addEventListener('scroll', requestMobileSubmitBarSync, { passive: true });
        document.addEventListener('click', requestMobileSubmitBarSync, true);
        document.addEventListener('keydown', requestMobileSubmitBarSync, true);
        document.addEventListener('cart:open', requestMobileSubmitBarSync);
        document.addEventListener('cart:opened', requestMobileSubmitBarSync);
        document.addEventListener('cart:open:error', requestMobileSubmitBarSync);

        if (window.MutationObserver) {
          new MutationObserver(requestMobileSubmitBarSync).observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class', 'aria-hidden'],
            subtree: true,
          });
        }
      }

      function getProductDetailsStickyTop() {
        if (!productDetails) return 0;

        var computedTop = window.getComputedStyle(productDetails).top;
        var stickyTop = parseFloat(computedTop);

        return isNaN(stickyTop) ? 0 : stickyTop;
      }

      function getWheelDeltaY(event) {
        if (event.deltaMode === 1) return event.deltaY * 16;
        if (event.deltaMode === 2) return event.deltaY * window.innerHeight;

        return event.deltaY;
      }

      function routeProductDetailsWheel(event) {
        if (!productDetails || window.matchMedia('(max-width: 749px)').matches) return;
        if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

        var detailsRect = productDetails.getBoundingClientRect();
        var isOverDetails = event.clientX >= detailsRect.left
          && event.clientX <= detailsRect.right
          && event.clientY >= detailsRect.top
          && event.clientY <= detailsRect.bottom;
        if (!isOverDetails) return;

        var maxScroll = productDetails.scrollHeight - productDetails.clientHeight;
        if (maxScroll <= 1) return;

        var stickyTop = getProductDetailsStickyTop();
        var productRect = productSection.getBoundingClientRect();
        var isPinned = detailsRect.top <= stickyTop + 1 && productRect.bottom > window.innerHeight;
        var currentScroll = productDetails.scrollTop;
        var deltaY = getWheelDeltaY(event);
        var isScrollingDown = deltaY > 0;
        var isScrollingUp = deltaY < 0;
        var isAtTop = currentScroll <= 1;
        var isAtBottom = currentScroll >= maxScroll - 1;
        var availableScroll = isScrollingDown ? maxScroll - currentScroll : currentScroll;
        var consumedScroll = Math.min(Math.abs(deltaY), availableScroll);
        var nextScroll = currentScroll + (isScrollingDown ? consumedScroll : -consumedScroll);
        var remainingScroll = Math.abs(deltaY) - consumedScroll;

        if (!isPinned) return;
        if ((isScrollingDown && isAtBottom) || (isScrollingUp && isAtTop) || consumedScroll <= 0.5) return;

        productDetails.scrollTop = nextScroll;
        event.preventDefault();

        if (remainingScroll > 0.5) {
          window.scrollBy({
            top: isScrollingDown ? remainingScroll : -remainingScroll,
            left: 0,
            behavior: 'auto',
          });
        }
      }

      productSection.addEventListener('wheel', routeProductDetailsWheel, { passive: false });

      function openSizeChartModal() {
        if (!sizeChartModal) return;

	        window.clearTimeout(sizeChartCloseTimer);
	        sizeChartPreviousFocus = document.activeElement;
	        if (releaseSizeChartAccessibility) releaseSizeChartAccessibility();
	        sizeChartModal.classList.remove('is-closing');
	        sizeChartModal.classList.add('is-open');
	        sizeChartModal.setAttribute('aria-hidden', 'false');
	        document.body.classList.add('size-chart-modal-is-open');

	        releaseSizeChartAccessibility = window.themeAccessibility
	          ? window.themeAccessibility.activateModal(sizeChartModal, sizeChartPanel)
	          : null;
	      }

      function closeSizeChartModal() {
        if (!sizeChartModal || !sizeChartModal.classList.contains('is-open')) return;

	        sizeChartModal.classList.remove('is-open');
	        sizeChartModal.classList.add('is-closing');
	        sizeChartModal.setAttribute('aria-hidden', 'true');

	        if (releaseSizeChartAccessibility) {
	          releaseSizeChartAccessibility();
	          releaseSizeChartAccessibility = null;
	        }

        sizeChartCloseTimer = window.setTimeout(function () {
          sizeChartModal.classList.remove('is-closing');
          document.body.classList.remove('size-chart-modal-is-open');
        }, 260);

        if (sizeChartPreviousFocus && typeof sizeChartPreviousFocus.focus === 'function') {
          sizeChartPreviousFocus.focus();
        }
      }

      productSection.querySelectorAll('[data-size-chart-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          openSizeChartModal();
        });
      });

      if (sizeChartModal && sizeChartModal.dataset.sizeChartInitialized !== 'true') {
        sizeChartModal.dataset.sizeChartInitialized = 'true';

        sizeChartModal.querySelectorAll('[data-size-chart-close]').forEach(function (button) {
          button.addEventListener('click', closeSizeChartModal);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && sizeChartModal.classList.contains('is-open')) {
            closeSizeChartModal();
          }
        });
      }

      function syncTabIndicator(activeButton) {
        if (!tabsNav || !activeButton) return;

        tabsNav.style.setProperty('--product-tabs-indicator-x', activeButton.offsetLeft + 'px');
        tabsNav.style.setProperty('--product-tabs-indicator-width', activeButton.offsetWidth + 'px');
      }

      function syncMobileAccordions() {
        if (!productTabs || !tabsNav) return;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        productSection.querySelectorAll('[data-product-tab]').forEach(function (button) {
          var panel = productSection.querySelector('[data-product-panel="' + button.dataset.productTab + '"]');
          if (!panel) return;

          if (isMobile) {
            if (panel.previousElementSibling !== button) {
              button.insertAdjacentElement('afterend', panel);
            }
          } else if (panel.parentElement !== productTabs) {
            productTabs.appendChild(panel);
          }
        });

	        if (!isMobile && !productSection.querySelector('[data-product-tab].is-active')) {
	          var firstButton = productSection.querySelector('[data-product-tab]');
	          var firstPanel = firstButton ? productSection.querySelector('[data-product-panel="' + firstButton.dataset.productTab + '"]') : null;

          if (firstButton && firstPanel) {
            firstButton.classList.add('is-active');
            firstButton.setAttribute('aria-selected', 'true');
            firstButton.setAttribute('aria-expanded', 'true');
            firstButton.tabIndex = 0;
            firstPanel.classList.add('is-active');
	            firstPanel.hidden = false;
	          }
	        }

	        productSection.querySelectorAll('[data-product-tab]').forEach(function (button) {
	          if (isMobile) {
	            button.tabIndex = 0;
	          } else {
	            button.tabIndex = button.classList.contains('is-active') ? 0 : -1;
	          }
	        });
	      }

      var productTabButtons = Array.prototype.slice.call(productSection.querySelectorAll('[data-product-tab]'));

      function activateProductTab(button) {
        var tab = button.dataset.productTab;
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var wasActive = button.classList.contains('is-active');

        if (tabsNav) tabsNav.classList.add('is-animated');

        productTabButtons.forEach(function (tabButton) {
          var isActive = tabButton === button && (!isMobile || !wasActive);
          tabButton.classList.toggle('is-active', isActive);
          tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tabButton.setAttribute('aria-expanded', isActive ? 'true' : 'false');
	          tabButton.tabIndex = isMobile || isActive ? 0 : -1;
        });

        productSection.querySelectorAll('[data-product-panel]').forEach(function (panel) {
          var isActive = panel.dataset.productPanel === tab && (!isMobile || !wasActive);
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        syncTabIndicator(button);
      }

      productTabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activateProductTab(button);
        });

        button.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % productTabButtons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + productTabButtons.length) % productTabButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = productTabButtons.length - 1;
          if (nextIndex === index) return;

          event.preventDefault();
          activateProductTab(productTabButtons[nextIndex]);
          productTabButtons[nextIndex].focus();
        });
      });

      syncMobileAccordions();
      syncTabIndicator(productSection.querySelector('[data-product-tab].is-active'));
      window.requestAnimationFrame(function () {
        if (tabsNav) tabsNav.classList.add('is-ready');
      });

      window.addEventListener('resize', function () {
        syncMobileAccordions();
        syncTabIndicator(productSection.querySelector('[data-product-tab].is-active'));
        syncMediaProgress();
        syncMobileSubmitBar();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
